import { Component, Vue } from 'vue-property-decorator';
import { HttpErrorEvent } from '@/services/event-bus';
import { ValidationError } from '@/models/errors/validation-error';

@Component
export default class ActionNotificationsComponent extends Vue {
    mounted() {
        this.$bus.$on(HttpErrorEvent, this.handleHttpError)
    }

    private handleHttpError(e) {
        if (e instanceof ValidationError) {
            this.$notify({
                group: 'action-notifications',
                title: 'Validation Error',
                text: this.getValidationErrorText(e),
                duration: 5000,
                type: 'danger',
            });
        }
    }

    private getValidationErrorText(error: ValidationError): string {
        if (!error) { return ''; }

        return error.errors
            .map(err => err.errors[0])
            .join('<br/>')
    }
}
